import { ROLES, CUSTOMER_ROLES } from '@/constants/roles';

export default [
  {
    path: '/export-list',
    name: 'export_list',
    component: () => import('@/views/pages/export-list/exportList.vue'),
    meta: {
      pageTitle: 'Export List',
      breadcrumb: {
        label: 'Export List'
      },
      verticalMenu: {
        title: 'Export List',
        icon: 'DownloadIcon',
        parent: 'Reporting'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ...CUSTOMER_ROLES]
    }
  }
];
